quickbet = {
    // Funkcia na zobrazenie quickbet buttonu
    showQuickBetButton: function(page, forceHide) {
        try {
            switch(page) {
                case "home":
                    $("#quickBetHome").show();
                    break;
                case "live":
                default:
                    if (forceHide) {
                        $("#quickBetOffer").hide();
                    } else {
                        $("#quickBetOffer").show();
                    }
                    break;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Funkcia sluzi na nastavenie quickBet buttonov na home page a v offere
    setQuickBetButtons: function(show) {
        try {
            if (show) {
                // QuickBety su zapnute
                $("#sportBox").find(".quick-bet").attr("style", "background-image: url(" + profile.QuickBets.Img + ")")
                .find(".left-icon").html("<div class='icon ui-icon-sports sport-" 
                + profile.QuickBets.SportID + " sport-color-"
                + profile.QuickBets.SportID + " sport-icon-"
                + profile.QuickBets.SportID + "'></div>");
                if (profile.QuickBets.IsNew) {
                    $("#sportBox").find(".quick-bet .info-header").show();
                }
                if (profile.QuickBets.HomePage) {
                    $("#home").addClass("has-quickbet");
                    quickbet.showQuickBetButton("home");
                } else {
                    $("#quickBetHome").hide();
                }
            } else {
                $("#sportBox").find(".quick-bet").hide().parent().removeClass("has-quickbet");
            }
        } catch (e) {
            main.closeDialog();
            $("#home").removeClass("has-quickbet");
            $("#quickBetHome").hide();
        }
    },

    // Funkcia odchytava stlacenie quickbet buttonov
    showQuickBet: function() {
        try {
            console.trace("showQuickbet()");
            if (more.asideLoading.inProgress) return; // Kontrola ci nie je spustene nejake schvalovanie tiketu
            if (restriction = ticket.playerNotAllowedForBetting()) {
                // Ak je restriction, nema moznost betovat
                quickbet.quickBetRender("");
            } else {
                // Tipovanie povolene
                stored.BetAll = false;
                if (stored.Balance < profile.MinDep) {
                    modal.showErrObj(2, 5, {err1: texts.TicketErr17, err2: "", errType: "default"});
                }
                if (stored.browser || !stored.WebBalanceActive) {
                    quickbet.getQuickBetToken();
                } else if (ShowPINVerification()) {
                    quickbet.getQuickBetToken();
                }
                return true;
            }
        } catch (e) {
            main.closeDialog();
            return false;
        }
    },

    // Funkcia sluzi na vyziadanie quickBet tokenu a nasledne zavola vykreslenie quickBetov
    getQuickBetToken: function() {
        try {
            var auth = false;
            var requestUrl = url.centralSB + "/session/" + stored.CID + "/";
            // TODO: Ked sa quickbety zapnu, treba skontrolovat funkcnost a spravne nastavenie podmienok:
            if (stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID) && stored.Token) {
                // Ak je hrac prihlaseny ma sucasne token a nejedna sa o manualne prihlaseneho hraca
                requestUrl += profile.LanguageIdDefault + "/webclientid/" + (stored.WebBalanceActive? true: false);
                auth = true;
            } else if ((profile.IsGamingClub && !stored.PlayerID) || (!profile.IsGamingClub && stored.PlayerID && stored.PlayerID === profile.ManualVerifiedPlayerID)) {
                // Pripad kedy webApp nema token (neprihlaseny hrac v herni || ne-hernova prevadzka a manualne overeny hrac)
                // Pre (neprihlaseny hrac v herni || ne-hernova prevadzka a manualne overeny hrac) plati: nemam k dispozicii hracsky token => nutne pouzit tento endopoint
                requestUrl += ((stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID)? stored.PlayerID: 0) + "/" + profile.LanguageIdDefault + "/webclientid/" + (stored.WebBalanceActive? true: false);
            } else {
                throw "quickbet.getQuickBetToken() when: stored.PlayerID: " + stored.PlayerID + " stored.Token: " + !!stored.Token;
            }
            $.ajax({
                type: "GET",
                url: requestUrl,
                dataType: "json",
                async: true,
                beforeSend: function(xhr) {
                    if (auth) {
                        xhr.setRequestHeader("Authorization", "Bearer " + stored.Token);
                    }
                }
            })
                .done(function(data) {
                    // Kontrola objektu
                    if (data === Object(data) && data.value) {
                        try {
                            main.createLog(3, "GetQuickBetToken_Success", "Token: " + data.value);
                            stored.TokenQuickBet = data.value;
                            quickbet.quickBetRender(data.value);
                        } catch (e) {
                            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                            main.createLog(2, "GetQuickBetToken_Failed", "# DATA: " + JSON.stringify(data));
                        }
                    } else {
                        // Ak server vratil not-object odpoved
                        modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                        main.createLog(2, "GetQuickBetToken_Failed", "# DATA: " + JSON.stringify(data));
                    }
                    return true;
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    main.createLog(2, "GetQuickBetToken_Error", " # AJAX FAILED: " + JSON.stringify(jqXHR));
                    modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                    return false;
                });
        } catch (e) {
            main.closeDialog();
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "GetQuickBetToken_Error", "# ERROR: " + e);
            return false;
        }
    },

    // Funkcia sluzi na vykreslenie quickBetov v iframe
    quickBetRender: function(token) {
        try {
            var quickBetUrl;
            if (profile.QuickBets.VideoOnTop) {
                communication.topScreen("quickbet", {
                    token: token,
                    lang: offer.lang
                });
                quickBetUrl = profile.QuickBets.UrlControls + "#/terminal/controls?sessionToken=" + token + "&lang=" + offer.lang;
            } else {
                quickBetUrl = profile.QuickBets.UrlControls + "#/bet?sessionToken=" + token + "&lang=" + offer.lang;
            }
            $("#quickBetIframe").attr("src", quickBetUrl);
            quickbet.listenQuickBetIframe();
            var e1 = eventDetail.eventDetailHeader(profile.QuickBets.SportID, texts[profile.QuickBets.SportName], 0, "Quickbet");
            $("#quickBetWrapper #eventTitle").removeAttr("class").html(e1);
            // Pridávam class aby som vedel modifikovať modal notifikácie keď je otvorený quickbet modal
            $("body").addClass("quickBetModal-open");
            main.dialogOpen("quickBet");
            $.mobile.changePage("#quickBetWrapper", {"role": "dialog"});
            $("#sportBox").addClass("full-opacity-background");
            // Refresh ak nastala zmena (nie užívateľom) QuickBet Prepínač - výhry pripisovať k zostatku
            $("#quickBetSwitchBalanceAutoAdd").checkboxradio("refresh");
            return true;
        } catch (e) {
            main.closeDialog();
            return false;
        }
    },

    // Funkcia listenera nad quickbet iframe
    quickBetIframeListener: function(ev) {
        try {
            if (profile.QuickBets.UrlControls.includes(ev.origin)) {
                if (ev.data && ev.data.event_id && ["place_bet_event", "result_bet_event", "terminal_change_event"].includes(ev.data.event_id)) {
                    // Akcia z iframu: bet, vysledok betu, zmena zapasu sa povazuju za akciu uzivatela, hraca neodhlasi koli necinnosti
                    main.userAction();
                }
                if (ev.data && ev.data.event_id && (ev.data.event_id === "place_bet_event")) {
                    if (ev.data.event_data.bet_id && ev.data.event_data.amount) {
                        // GA4 - trackovanie pridania oddu na ticket - quickbety
                        gtag('event', 'add_to_cart', {'items': [{
                            'item_id': 'JT-QB',
                            'item_category': 'Stolný tenis',
                            'item_category2': 'Quickbets',
                            'item_category3': 'Quickbets',
                            'item_list_name': offer.page,
                        }]});
                        main.userAction();
                        ticket.actionQuickBetTicketPrint(ev.data.event_data.bet_id, ev.data.event_data.amount);
                        // GA4 - trackovanie podania ticketu - quickbety
                        try {
                            gtag('event', 'purchase', {
                                'transaction_id': "QB_" + ev.data.event_data.bet_id,
                                'value': ev.data.event_data.amount, 
                                'currency': profile.Default.CurrencyCode,
                                'items': [{
                                    'item_id': 'JT-QB',
                                    'item_category': 'Stolný tenis',
                                    'item_category2': 'Quickbets',
                                    'item_category3': 'Quickbets'
                                }]
                            });
                        } catch (error) {
                            console.error(error);
                        }
                        return true;
                    }
                    main.createLog(2, "quickBetIframeListener_Failed", "event_id: " + ev.data.event_id + " bet_id: " + ev.data.event_data.bet_id + " amount: " + ev.data.event_data.amount);
                    return false;
                }
                // Odosielanie výherných ticketov na nativeapp
                if (ev.data && ev.data.event_id && (ev.data.event_id === "result_bet_event")) {
                    if (!stored.QuickBetSwitchBalanceAutoAdd) {
                        clearTimeout(rfs.myTickets);
                        rfs.myTickets = setTimeout(function() {
                            if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                                player.playerTickets.myTicketsFilter(false, true);
                            } else {
                                delete cache.MyTickets;
                            }
                        }, 1000);
                    }

                    // Possible values: [new, accepted, rejected, won, lost, cancelled, review]
                    // Posielať vždy len výherné alebo skontované
                    if (ev.data.event_data && ev.data.event_data.status && ["won", "cancelled"].includes(ev.data.event_data.status) && ev.data.event_data.win_amount) {
                        // Testujem či je otvorený quickbet modal aby som nastavil text a dizajn hlášky: sev = ticket
                        if ($.mobile.activePage.is("#quickBetWrapper") && stored.TokenQuickBet) {
                            if (ev.data.event_data.status === "won") {
                                // Notifikácia pre výherný quickbet ticket "win_amount": ##,##
                                modal.showErrObj("ticket", 5, {err1: texts.QuickBetNotificationWin, err2: texts.QuickBetNotificationWinAmount + " " + shared.floor2(ev.data.event_data.win_amount, 1) + " " + profile.Currency, errType: "WonMessage"});
                            } else if (ev.data.event_data.status === "cancelled") {
                                // Notifikácia pre skontovaný quickbet ticket (vklad bude vrateny hracovi)
                                modal.showErrObj(2, 5, {err1: texts.QuickBetNotificationCancelled, err2: texts.QuickBetNotificationInfoCancelled, errType: "BetCancelled"});
                            }
                        }
                        // Odoslanie cez js funkciu do nativeapp
                        if (stored.QuickBetSwitchBalanceAutoAdd) {
                            // Ak je povolené automatické pripisovanie 
                            ticket.ticketConfirmQuickBet(ev.data.event_data.bet_id);
                        }
                        return true;
                    }
                };
                var data;
                if (ev.data.event_id === "terminal_clear_event") {
                    data = { event_id: "change_event" , event_data: { event_id: 0 }};
                } else if (ev.data.event_id === "terminal_change_event") {
                    data = { event_id: "change_event", event_data: { event_id: ev.data.event_data.event_id }};
                    document.getElementById("quickBetIframe").contentWindow.postMessage(data, profile.QuickBets.UrlControls);
                } else {
                    data = ev.data;
                }
                if (data) {
                    communication.topScreen("quickbetControl", {
                        data: data
                    });
                }
                return true;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na odchytenie udalosti z quickbet iframe
    listenQuickBetIframe: function() {
        try {
            window.removeEventListener("message", quickbet.quickBetIframeListener);
            window.addEventListener("message", quickbet.quickBetIframeListener);
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na skrytie a vycistenie okna quickBetov
    closeQuickBet: function() {
        try {
            stored.TokenQuickBet = null;
            $("#quickBetIframe").attr("src", "");
            quickbet.toggleQuickBetRules(true);
            $("#sportBox").removeClass("full-opacity-background");
            // Odoberám class ktorá modifikuje modal notifikácie keď je otvorený quickbet modal
            $("body").removeClass("quickBetModal-open");
            $("#quickBetVideoWrapper").hide();
            communication.topScreen("quickbet", {
                token: false
            });
            return true;
        } catch (e) {
            return false;
        }
    },

    // Funkcia sluzi na prepinanie stavu automatickeho pripisovanie vyhry k zostatku (Nastavenie sa neuklada do hracskeho profilu)
    handleQuickBetSwitchBalanceAutoAdd: function(state) {
        if (state == true) {
            stored.QuickBetSwitchBalanceAutoAdd = true;
        } else {
            stored.QuickBetSwitchBalanceAutoAdd = false;
        }
    },

    // Funkcia na otvaranie/zatvaranie pravidiel v detiale okna s quickbetom
    toggleQuickBetRules: function(forceClose) {
        try {
            if ($.mobile.activePage.is("#quickBetWrapper")) {
                if (forceClose || $("#quickBetRulesWrapper").is(":visible")) {
                    $("#quickBetRulesContent").scrollTop(0);
                    $("#quickBetRulesWrapper").queue();
                    $("#quickBetRulesWrapper").animate({
                        left: "-321px"
                      });
                    $("#quickBetRulesWrapper").dequeue().hide();

                } else {
                    $("#quickBetRulesWrapper").show();
                    $("#quickBetRulesWrapper").queue();
                    $("#quickBetRulesWrapper").animate({
                        left: "0px"
                      });
                    $("#quickBetRulesWrapper").dequeue();
                }
                return true;
            }
            return false;
        } catch (e) {
            $("#quickBetRulesWrapper").hide();
            return false;
        }
    }
};
